import type { NodeData, NodeId, NodeType, SnapshotId } from '@ipfabric/utils';
import type { NodeStableData } from 'components/Graph/model/selectors/selectNodesStableData';
import type { CompareMode } from '../deviceViewTypes';
import type { ShowNodeDetailCommand } from '../model/commands/showNodeDetail';

const getCompareMode = (
  nodeData: NodeData | NodeStableData,
  snapshotToCompareId: SnapshotId | null,
): CompareMode | null => {
  if (snapshotToCompareId !== null) {
    if (nodeData.style?.background === 'green') {
      return 'added';
    }
    if (nodeData.style?.background === 'red') {
      return 'removed';
    }
    return 'untouched';
  }
  return null;
};

export const getShowNodeDetailArgs = (
  deviceId: NodeId,
  nodeData: NodeData | NodeStableData,
  parentNodeData: NodeData | null,
  nodeHasPathInspectorDetail: boolean,
  nodeType: NodeType,
  snapshotToCompareId: SnapshotId | null,
): ShowNodeDetailCommand => ({
  compareMode: getCompareMode(nodeData, snapshotToCompareId),
  deviceId,
  extra: nodeData.extra,
  nodeType,
  intentCheckResult: nodeData.intentCheckResult,
  isPathLookupNode: nodeData.graphType === 'pathLookup',
  nodeHasPathInspectorDetail,
  parentNodeSn: parentNodeData?.sn ?? undefined,
  parentNodeType: parentNodeData?.type ?? undefined,
  sn: nodeData.sn,
  title: nodeData.label,
});
